import { WorkflowListFilters } from './types'
import { WorkflowsFieldToOrderBy, WorkflowsPermissionsType } from './enums'
import { SortDirection } from '../common'
import { WorkflowsExecutionStatus } from './enums'
import { JobStatusType } from '../jobs/types'

export const API_COMPONENT = 'native.output'

export const MCP_TOOL_COMPONENT = 'native.mcptooloutput'

export const CONTROL_COMPONENTS = ['native.ifelse', 'native.successerror']

export const SINGLE_USE_COMPONENTS = [API_COMPONENT, MCP_TOOL_COMPONENT]

export const ENRICH_COMPONENTS = [
  'native.quadbinenrich',
  'native.h3enrich',
  'native.enrichpolygons',
  'native.enrichpoints'
]

export const TILESET_COMPONENTS = [
  'native.createvectortileset',
  'native.createpointaggtileset',
  'native.createh3aggtileset',
  'native.createquadbinaggtileset'
]

export const NOTIFY_COMPONENTS = ['SaveToBucketAndNotify']

export const EXPORT_DATA_COMPONENTS = ['native.exportdata']

export const RASTER_COMPONENTS = ['carto.extractraster', 'carto.intersectraster']

export const BUILDER_MAP_COMPONENTS = ['native.createbuildermap']

export const COMPONENTS_WITHOUT_OUTPUT = [
  ...SINGLE_USE_COMPONENTS,
  ...CONTROL_COMPONENTS,
  ...TILESET_COMPONENTS,
  ...NOTIFY_COMPONENTS
]

export const REACT_FLOW_MIN_ZOOM = 0.1

export const REGIONS = {
  US: 'US',
  EU: 'EU'
}

export const REGION_ALIASES = {
  'asia-northeast1': 'AS',
  'australia-southeast1': 'AU'
}

export const TENANT_REGION: Record<string, string> = {
  'gcp-us-east1': REGIONS.US,
  'gcp-europe-west1': REGIONS.EU,
  'gcp-asia-northeast1': 'asia-northeast1',
  'gcp-australia-southeast1': 'australia-southeast1'
}

export const KEYS = {
  workflows: 'workflows' as const,
  latestWorkflows: 'latestWorkflows' as const,
  demoWorkflows: 'demoWorkflows' as const,
  demoDetails: 'demoDetails' as const,
  workflow: 'workflow' as const,
  componentSchemas: 'componentSchemas' as const,
  customComponents: 'customComponents' as const,
  workflowSave: 'workflowSave' as const,
  componentDataPreview: 'componentDataPreview' as const,
  workflowTablePermissions: 'workflowTablePermissions' as const,
  dataObservatory: 'dataObservatory' as const,
  workflowDataTableStats: 'workflowDataTableStats' as const,
  doSource: 'doSource' as const,
  source: 'source' as const,
  genericSourceNode: 'genericSourceNode' as const,
  importedTables: 'importedTables' as const,
  workflowTemplates: 'workflowTemplates' as const,
  packageExtensionGallery: 'packageExtensionGallery' as const,
  packageExtensions: 'packageExtensions' as const,
  namedSources: 'namedSources' as const,
  workflowTools: 'workflowTools' as const
}

export const POOLING_JOB_INTERVAL_MS = 2000

export const DEFAULT_FILTERS: WorkflowListFilters = {
  search: '',
  order: {
    order_by: WorkflowsFieldToOrderBy.UpdatedAt,
    order_direction: SortDirection.Desc
  },
  permissions: WorkflowsPermissionsType.All
}

export const DEFAULT_PAGE_SIZE = 12

export const WORKFLOW_STATUS_BY_JOB_STATUS_TYPE = {
  [JobStatusType.Running]: WorkflowsExecutionStatus.Running,
  [JobStatusType.Pending]: WorkflowsExecutionStatus.Running,
  [JobStatusType.Failure]: WorkflowsExecutionStatus.Done,
  [JobStatusType.Success]: WorkflowsExecutionStatus.Done,
  [JobStatusType.Cancelled]: WorkflowsExecutionStatus.Unexecuted
}

export const WORKFLOW_NODE_TYPE = {
  Source: 'source',
  Generic: 'generic',
  Note: 'note',
  File: 'file',
  SourceDO: 'SourceDO',
  RasterSource: 'raster'
}

export const WORKFLOW_EDGE_TYPE = {
  Default: 'default'
}

export const WORKFLOW_Z_INDEX_NODE_TYPE = {
  [WORKFLOW_NODE_TYPE.Note]: -1,
  [WORKFLOW_NODE_TYPE.Source]: 2,
  [WORKFLOW_NODE_TYPE.Generic]: 2,
  [WORKFLOW_NODE_TYPE.File]: 2,
  [WORKFLOW_NODE_TYPE.SourceDO]: 2
}

export const WORKFLOW_TEMPLATES_URL = 'https://academy.carto.com/creating-workflows/workflow-templates'

export const INPUT_FILE_ACCEPT = '.zip,.geojson,.json,.tar,.gz,.tgz,.csv,.kml,.gpkg,.kmz,.tsv,.parquet'

export const ALL_TEMPLATES_CATEGORY = 'All templates'

export const WORKFLOWS_CLASSNAMES = {
  GROUP_ANIMATION: 'group-animation'
}
export const UNDO_STACK_MAX_SIZE = 50
